import { sortTypes } from '../constants'

import actionTypes from './actionTypes'

// For setting initial folder state
// and for reordering root level folders
const setFolders = folders => ({
  type: actionTypes.setFolders,
  payload: folders,
})

const setCurrentFolderId = folderId => ({
  type: actionTypes.setCurrentFolderId,
  payload: folderId,
})

// FOLDER actionTypes
const createFolder = folder => ({
  type: actionTypes.createFolder,
  payload: folder,
})

const updateFolder = ({ id, name, description }) => ({
  type: actionTypes.updateFolder,
  payload: {
    id,
    name,
    description,
  },
})

const addPublishedFolder = folder => ({
  type: actionTypes.addPublishedFolder,
  payload: folder,
})

const removePublishedFolder = folderId => ({
  type: actionTypes.removePublishedFolder,
  payload: folderId,
})

const adjustFolderShares = folder => ({
  type: actionTypes.adjustFolderShares,
  payload: folder,
})

const removeFolderShares = folderId => ({
  type: actionTypes.removeFolderShares,
  payload: folderId,
})

const deleteFolder = folderId => ({
  type: actionTypes.deleteFolder,
  payload: folderId,
})

// FOLDER ITEM actionTypes

// When moving folder items, the endpoint responds with an array
// of folders which changed as a result of the move
const updateChangedFolders = changedFolders => ({
  type: actionTypes.updateChangedFolders,
  payload: changedFolders,
})

const deleteItem = ({ folderId, itemId }) => ({
  type: actionTypes.deleteFolderItem,
  payload: {
    folderId,
    itemId,
  },
})

// UI
const setNewPublished = bool => ({
  type: actionTypes.setNewPublished,
  payload: bool,
})

const setNewShared = bool => ({
  type: actionTypes.setNewShared,
  payload: bool,
})

const sortAscending = () => ({
  type: actionTypes.sortAscending,
  payload: sortTypes.ascending,
})

const sortDescending = () => ({
  type: actionTypes.sortDescending,
  payload: sortTypes.descending,
})

const sortManual = () => ({
  type: actionTypes.sortManual,
  payload: sortTypes.manual,
})

const sortSharedAscending = () => ({
  type: actionTypes.sortSharedAscending,
  payload: sortTypes.ascending,
})

const sortSharedAuthor = () => ({
  type: actionTypes.sortSharedAuthor,
  payload: sortTypes.author,
})

const sortSharedDate = () => ({
  type: actionTypes.sortSharedDate,
  payload: sortTypes.date,
})

const sortSharedDescending = () => ({
  type: actionTypes.sortSharedDescending,
  payload: sortTypes.descending,
})

export default {
  addPublishedFolder,
  adjustFolderShares,
  createFolder,
  deleteFolder,
  deleteItem,
  removeFolderShares,
  removePublishedFolder,
  setCurrentFolderId,
  setFolders,
  setNewPublished,
  setNewShared,
  sortAscending,
  sortDescending,
  sortManual,
  sortSharedAscending,
  sortSharedAuthor,
  sortSharedDate,
  sortSharedDescending,
  updateChangedFolders,
  updateFolder,
}
